import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import NetworkService from "../../services/NetworkService";
import EnergyTableComponent from "../../components/EnergyTableComponent";
import jsPDF from "jspdf";
import { energyTableView } from "../../assets/tableViews";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { useMsal, useAccount } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

function EnergyTable() {
  const [currentTabTitle, setCurrentTabTitle] = useState("Active CC");
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [businessPlans, setBusinessPlans] = useState([]);
  const [residentialPlans, setResidentialPlans] = useState([]);
  const [smbPlans, setSMBPlans] = useState([]);
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [accessToken, setAccessToken] = useState();

  useEffect(() => {
    console.log(account);
    async function getData() {
      if (account) {
        instance
          .acquireTokenSilent({
            ...loginRequest,
            account: account,
          })
          .then((response) => {
            console.log("CH", response);
            setAccessToken(response.accessToken);
            return response.accessToken;
          })
          .then((token) => {
            const networkServiceObj = new NetworkService();
            networkServiceObj
              .getEnergyPlanService(token)
              .then((res) => {
                setCurrentData(res.data);
                setBusinessPlans([
                  ...businessPlans,
                  res.data?.filter((x) => x.customerGroup === "C&I"),
                ]);
                setResidentialPlans([
                  ...residentialPlans,
                  res.data?.filter((x) => x.customerGroup === "Residential"),
                ]);
                setSMBPlans([...smbPlans, res.data?.filter((x) => x.customerGroup === "SMB")]);
              })
              .then(() => setLoading(false));
          });
      }
    }
    setLoading(true);
    getData();
  }, []);

  const handleTabChange = (key) => {
    const currentTab = secondTab.find((t) => t.key === key);
    if (!currentTab) return;
    const tabLabel = currentTab.label;
    setCurrentTabTitle(tabLabel);
  };

  const handleExportExcel = async (fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const innerHTML = document.querySelector(".test-data").innerHTML;
    const currentTableData = JSON.parse(innerHTML);
    const ws = XLSX.utils.json_to_sheet(currentTableData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const getColumns = () => {
    switch (currentTabTitle) {
      case "Active CC":
        return energyTableView.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      case "Active REC":
        return energyTableView.map((c) => ({ header: c.title, dataKey: c.dataIndex }));
      default:
        return null;
    }
  };

  // Currently, there is only 1 dummy data (and 1 default column).
  // Meaning, regardless of which Tab is opened, whatever is
  // displayed in the table will be exported INCLUDING all the Object
  // keys found in the dummy data.
  const handleExportPdf = (fileName) => {
    const innerHTML = document.querySelector(".test-data").innerHTML;
    const currentTableData = JSON.parse(innerHTML);
    const width = 1400;
    const height = 581.703125;
    require("jspdf-autotable");
    const report = new jsPDF("landscape", "pt", "a4");
    // get all the header columns of the table
    // do not include the "Tabe Operation" column
    // const cols = activeCC.map(c => ({ title: c.title }))
    const cols2 = getColumns();
    const indexOfObject = cols2.findIndex((object) => {
      return object.header === "Table Operation";
    });
    if (cols2.find((e) => e.header === "Table Operation")) {
      cols2.splice(indexOfObject, 1);
    }

    // Flatten each object's values
    // do not include the first element, "key"
    const temp = currentTableData.map((d) => {
      const x = Object.values(d);
      return x;
    });

    const xOffset = report.internal.pageSize.width / 2;
    report.text(currentTabTitle, xOffset, 8, { align: "center" });
    report.autoTable({
      body: currentTableData,
      columns: cols2,
    });
    report.save(fileName + ".pdf");
  };

  const secondTab = [
    {
      key: 1,
      label: "C&I Energy Plans",
      children: (
        <EnergyTableComponent
          defaultColumns={energyTableView}
          dummyData={businessPlans[0]}
          label={"CC"}
          token={accessToken}
        ></EnergyTableComponent>
      ),
      forcedRender: true,
    },
    {
      key: 2,
      label: "Residential Energy Plans",
      children: residentialPlans[0] != null && (
        <EnergyTableComponent
          defaultColumns={energyTableView}
          dummyData={residentialPlans[0]}
          label={"CC"}
          token={accessToken}
        ></EnergyTableComponent>
      ),
      forcedRender: true,
    },
    {
      key: 3,
      label: "SMB Energy Plans",
      children: smbPlans[0] != null && (
        <EnergyTableComponent
          defaultColumns={energyTableView}
          dummyData={smbPlans[0]}
          label={"CC"}
          token={accessToken}
        ></EnergyTableComponent>
      ),
      forcedRender: true,
    },
  ];

  const viewPdf = (pdfData) => {
    // using Java Script method to get PDF file
    fetch(
      "https://gcs-dev-web.azurewebsites.net/api/Certificate/DownloadCertificate?certificateNo=C230000064&mssl=1234567890&accountNo=GC3699933S",
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    ).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "SamplePDF.pdf";
        alink.click();
      });
    });
  };

  return (
    <div className="App">
      {loading === false && (
        <Tabs
          defaultActiveKey="1"
          items={secondTab}
          onChange={handleTabChange}
          destroyInactiveTabPane={true}
        ></Tabs>
      )}
      {}
    </div>
  );
}

export default EnergyTable;
